export type ReaderView = "text" | "comments" | "ai";

export const DIRECT_READER_JUMP: ScrollIntoViewOptions = {
  behavior: "auto",
  block: "start",
};

export const TOC_REVEAL: ScrollIntoViewOptions = {
  behavior: "auto",
  block: "nearest",
};

export function tocAccessibleLabel(section: string, title: string, page: number): string {
  return `${section} · ${title} · P.${page}`;
}

export function chineseTocTitle(title: string): string {
  let displayTitle = title.trim();
  while (displayTitle) {
    const suffix = displayTitle.match(/\s*[（(]([^（）()]*)[）)]\s*$/u);
    if (!suffix || !/[A-Za-z]/u.test(suffix[1])) break;
    displayTitle = displayTitle.slice(0, suffix.index).trim();
  }
  return displayTitle || title.trim();
}

const COMPACT_TOC_SECTIONS: Record<string, string> = {
  "研究文章摘要": "研究",
  "科学摘要": "摘要",
  "专题报道": "专题",
};

export function compactTocSection(section: string): string {
  return COMPACT_TOC_SECTIONS[section] ?? section;
}

export function isReaderDrawerView(view: ReaderView): boolean {
  return view === "comments" || view === "ai";
}
